import { Component, input, model, output } from '@angular/core';

@Component({
  selector: 'ag-discard-confirmation-modal',
  templateUrl: './discard-confirmation-modal.component.html',
  standalone: false,
})
export class DiscardConfirmationModalComponent {
  visible = model<boolean>(false);
  title = input.required<string>();
  body = input.required<string>();

  readonly acceptButtonLabel = 'Yes, exit page';
  readonly cancelButtonLabel = 'Cancel';

  confirmed = output<void>();
  cancelled = output<void>();

  onConfirm(): void {
    this.confirmed.emit();
    this.visible.set(false);
  }

  onCancel(): void {
    this.cancelled.emit();
    this.visible.set(false);
  }
}
